import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onMount", "onUnmount"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import PropTypes from 'prop-types';

/**
 * На текущий момент поддерживает только mount,
 * можно добавить еще onMountChange({ type })
 */
export function withMountListener(WrappedComponent) {
  var MountListener = function MountListener(_ref) {
    var onMount = _ref.onMount,
      onUnmount = _ref.onUnmount,
      props = _objectWithoutProperties(_ref, _excluded);
    React.useEffect(function () {
      onMount === null || onMount === void 0 ? void 0 : onMount();
    }, [onMount]);
    // onUnmount сохраняется в момент монтирования
    // нужен useWillUnmount, который сохраняет callback в ref и вызывает последнюю версию этого callback'а.
    React.useEffect(function () {
      return function () {
        onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount();
      };
    }, []);
    return /*#__PURE__*/React.createElement(WrappedComponent, props);
  };
  MountListener.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread(_objectSpread({}, WrappedComponent.propTypes), {}, {
    onMount: PropTypes.func,
    onUnMount: PropTypes.func
  }) : {};
  return MountListener;
}